import Layout from "../layouts/LayoutDefault.jsx";
import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import MakeGetRequest from "../components/utils/MakeGetRequest.jsx";
import MainContainer from "../components/MainContainer.jsx";
import BandMiniProfile from "../components/discover_page/BandMiniProfile.jsx";
import TitleTextSection from "../components/TitelTextSection.jsx";
import SearchFilterBand from "../components/discover_page/SearchFilterBand.jsx";
import CommercialBanner from "../components/CommercialBanner.jsx";

const DiscoverPage = () => {
  const [searchTerms, setSearchTerms] = useState(null); // The terms to use in api-call
  const [searchParams, setSearchParams] = useSearchParams(); // Browsers current Params
  const navigate = useNavigate();
  const pageFromUrl = searchParams.get("page");
  const [currentPageNr, setCurrentPageNr] = useState(() => {
    return pageFromUrl ? Number(pageFromUrl) : 1;
  });

  // Fetch Band data
  const { data, error, loading } = MakeGetRequest({
    route: `discover_bands?page=${currentPageNr}${
      searchTerms ? "&" + searchTerms : ""
    }`,
    errorCodeRedirect: 404,
  });
  // Sync the page number state with the URL parameter or filter params
  useEffect(() => {
    // Page Nr
    const pageFromUrl = searchParams.get("page");
    if (pageFromUrl && Number(pageFromUrl) !== currentPageNr) {
      setCurrentPageNr(Number(pageFromUrl));
    }
    // Filter params
    const urlParams = Object.fromEntries(searchParams.entries());
    const { page, ...restFilters } = urlParams; // Exclude page
    const params = new URLSearchParams(restFilters).toString();

    setSearchTerms(params);
  }, [searchParams]);

  if (data) {
    const handleFilterUpdate = (newFilter) => {
      setCurrentPageNr(1);
      // Remove keys with empty values from the newFilter object
      const cleanFilter = Object.fromEntries(
        Object.entries(newFilter).filter(([key, value]) => value !== ""),
      );
      // Construct the query string with the cleaned filter
      const params = new URLSearchParams(cleanFilter).toString();
      setSearchTerms(params);
      navigate(`?page=1${params ? "&" + params : ""}`, { replace: true });
    };

    {
      /* Pagination */
    }
    const goToNextPage = () => {
      if (currentPageNr < data.paginator.total_pages) {
        setCurrentPageNr((prevPage) => prevPage + 1);
        navigate(
          `?page=${currentPageNr + 1}${searchTerms ? `&${searchTerms}` : ""}`,
          {
            replace: true,
          },
        );
      }
    };

    const goToPreviousPage = () => {
      if (currentPageNr > 1) {
        setCurrentPageNr((prevPage) => prevPage - 1);
        navigate(
          `?page=${currentPageNr + 1}${searchTerms ? `&${searchTerms}` : ""}`,
          {
            replace: true,
          },
        );
      }
    };

    return (
      <>
        <Layout
          title="Upptäck"
          description="Leta och filtera mellan geners och musikkonstelationstyper för att hitta din nya favorit"
        >
          <MainContainer>
            <div className="sm:py-4 flex justify-between items-center">
              <TitleTextSection
                title="Upptäck ny musik"
                subtitle={`${data.paginator.total_count ?? ""} artister och band i Strängnäs kommun`}
              />
            </div>

            {/* Filter */}
            <div className="mb-8 p-6 rounded-2xl border border-white/10 bg-[#131313] shadow-md">
              <p className="font-bold text-[#0047ff] uppercase tracking-wider text-xs mb-4">
                Filter
              </p>
              <SearchFilterBand
                filter={data.filter_data}
                setUpdateFilter={handleFilterUpdate}
              />
            </div>

            {/* Grid of bands */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {data.bands.map((band, index) => (
                <React.Fragment key={index}>
                  {index === 6 && (
                    <div className="col-span-1 sm:col-span-2 lg:col-span-3">
                      <CommercialBanner />
                    </div>
                  )}
                  <BandMiniProfile band={band} />
                </React.Fragment>
              ))}
            </div>

            {/* Pagination */}
            <div className="w-full flex justify-center my-10">
              <div className="join shadow-md">
                <button
                  className="join-item btn bg-[#131313] border border-white/10 text-stone-300 hover:bg-neutral-800 disabled:opacity-30 rounded-l-full px-4 font-bold"
                  onClick={goToPreviousPage}
                  disabled={currentPageNr === 1}
                >
                  «
                </button>
                <button className="join-item btn bg-[#131313] border-y border-white/10 border-x-0 text-stone-300 pointer-events-none font-bold">
                  Sida {currentPageNr}{" "}
                  <span className="text-stone-500 font-semibold ml-1">
                    av {data.paginator.total_pages}
                  </span>
                </button>
                <button
                  className="join-item btn bg-[#131313] border border-white/10 text-stone-300 hover:bg-neutral-800 disabled:opacity-30 rounded-r-full px-4 font-bold"
                  onClick={goToNextPage}
                  disabled={currentPageNr === data.paginator.total_pages}
                >
                  »
                </button>
              </div>
            </div>
          </MainContainer>
        </Layout>
      </>
    );
  }
};

export default DiscoverPage;
